module.exports = __webpack_public_path__ + "img/logo-softnet.ba9b778f.png";